import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { kebabCase } from 'lodash';
const ConformanceTooltip = ({
  errorText: _errorText = null,
  placement: _placement = 'bottom',
  target: _target = null
}) => {
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const display = _errorText && _errorText.length ? /*#__PURE__*/React.createElement(Tooltip, {
    trigger: "hover",
    placement: _placement,
    isOpen: tooltipIsOpen,
    "data-testid": `t-ct-${kebabCase(_errorText)}`,
    target: _target,
    toggle: () => setTooltipIsOpen(!tooltipIsOpen),
    autohide: false
  }, _errorText) : null;
  return display;
};
ConformanceTooltip.propTypes = {
  errorText: PropTypes.string,
  target: PropTypes.string,
  placement: PropTypes.string
};
export default ConformanceTooltip;